import classNames from 'classnames';
import React from 'react';

import AttentionMessage from './AttentionMessage';
import { ErrorMessageProps } from './types';

const ErrorMessage = ({ severe = false, ...rest }: ErrorMessageProps) => {
    return (
        <AttentionMessage
            type="error"
            className={classNames({ 'sgw-attention-message__error-severe': severe })}
            {...rest}
        />
    );
};

export default ErrorMessage;
